import React from 'react';
import { Tabs, Tab, withStyles } from '@material-ui/core';
import PickupInfoGrid from './PickupInfoGrid/PickupInfoGrid';
import PickupInfoGridControls from './PickupInfoGrid/GridControls';
import { PICKUP_INFO_GRID_TABS } from './pickupInfoGridTabConstants';
import pickupInfoGridTabStyles from './pickupInfoGridTabStyles';

export type GroupPickupShipmentDetailsPanelProps = {
  classes: Record<string, string>;
  shipmentInfo: { data?: unknown[]; gridStatus?: string };
  pickInfoStateData: Record<string, unknown>;
  loadPickupShipmentData: () => void;
};

/**
 * Group pickup dialog: shipment grid with a single non-switchable "Shipment Details" header.
 */
const GroupPickupShipmentDetailsPanel: React.FC<GroupPickupShipmentDetailsPanelProps> = ({
  classes,
  shipmentInfo,
  pickInfoStateData,
  loadPickupShipmentData
}) => (
  <>
    <div className={classes.tabsHeaderContainer}>
      <Tabs
        value={PICKUP_INFO_GRID_TABS.shipmentDetailsTab}
        classes={{ indicator: classes.tabsIndicator }}
        indicatorColor="primary">
        <Tab
          classes={{
            root: classes.tabRoot,
            selected: classes.tabSelected,
            labelContainer: classes.labelContainer
          }}
          label="Shipment Details"
          value={PICKUP_INFO_GRID_TABS.shipmentDetailsTab}
        />
      </Tabs>
      <PickupInfoGridControls gridInfo={shipmentInfo} loadShipmentsData={loadPickupShipmentData} />
    </div>
    <PickupInfoGrid gridInfo={shipmentInfo} pickInfoStateData={pickInfoStateData} />
  </>
);

export default withStyles(pickupInfoGridTabStyles)(GroupPickupShipmentDetailsPanel);
